import { P } from 'components'
import PMBSelect from 'components/PMBSelect'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

/**
 * PMBYearFilter Component
 * Reusable year filter component that generates year options from user's profile.createdAt to current year
 *
 * @param {object} value - Selected year object { value: number, label: string }
 * @param {function} onChange - Callback when year changes, receives selected year object
 * @param {string} label - Label for the filter (default: 'Tahun')
 * @param {number} minYear - Minimum year (optional, overrides profile.createdAt)
 * @param {number} maxYear - Maximum year (optional, overrides current year)
 * @param {boolean} disabled - Disable the select
 * @param {string} placeholder - Placeholder text (default: 'Pilih tahun')
 */
const PMBYearFilter = ({
  value,
  onChange,
  label = 'Tahun',
  minYear,
  maxYear,
  disabled = false,
  placeholder = 'Pilih tahun',
  testId = 'pmb-year-filter',
  ...props
}) => {
  const { profile } = useSelector((s) => s.dashboard)
  const [yearOptions, setYearOptions] = useState([])

  useEffect(() => {
    const currentYear = new Date().getFullYear()

    const resolvedMinYear =
      minYear ||
      (profile?.createdAt
        ? new Date(profile.createdAt).getFullYear()
        : currentYear - 10)

    const resolvedMaxYear = maxYear || currentYear

    const years = []
    for (let i = resolvedMinYear; i <= resolvedMaxYear; i++) {
      years.push({ value: i, label: String(i) })
    }

    setYearOptions(years)

    if (!value && onChange) {
      const currentYearOption =
        years.find((y) => y.value === currentYear) || years[years.length - 1]

      onChange(currentYearOption)
    }
  }, [minYear, maxYear, profile, value, onChange])

  return (
    <div className="pmb-year-filter" data-testid={testId} {...props}>
      {label && (
        <P size="medium" className="mb-2">
          {label}
        </P>
      )}
      <PMBSelect
        value={value}
        onChange={onChange}
        options={yearOptions}
        isMulti={false}
        placeholder={placeholder}
        isDisabled={disabled}
      />
    </div>
  )
}

export default PMBYearFilter
